import { cn } from '@/utils/cn';

interface WhoWeAreProps {
  className?: string;
}

export function WhoWeAre({ className }: WhoWeAreProps) {
  return (
    <section className={cn("py-16 bg-white", className)}>
      <div className="container mx-auto px-4 max-w-4xl text-center">
        <h2 className="text-sm font-medium tracking-[0.2em] text-gray-400 uppercase mb-8">
          WHO WE ARE
        </h2>
        
        <div className="space-y-8">
          <p className="text-2xl md:text-3xl leading-relaxed text-gray-900 font-medium">
            Crystal Air is a family-owned and operated aviation company located in 
            Chattanooga, Tennessee. We've been getting people off the ground through flight 
            training and charter flights since 1993.
          </p>
          
          <div>
            <a 
              href="/about" 
              className="inline-block bg-blue-600 hover:bg-blue-700 text-white font-semibold px-8 py-3 rounded-md transition-colors duration-200"
            >
              Learn More
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}